import React from 'react';
import Image from 'next/image';
import { ubuntu } from '@/globalConstants';

type PageBannerProps = {
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    breadcrumb?: React.ReactNode;
    meta?: React.ReactNode;
    align?: 'left' | 'center';
    className?: string;
    logoAlt?: string;
};

const PageBanner: React.FC<PageBannerProps> = ({
    title,
    subtitle,
    breadcrumb,
    meta,
    align = 'center',
    className = '',
    logoAlt = 'Dharmayana Logo',
}) => {
    const isCenter = align === 'center';

    return (
        <div
            // Marks the end of this page's header artwork. SiteHeader watches for this
            // element scrolling fully out of view before it draws its scalloped edge.
            data-header-image
            className={`relative w-full min-h-[450px] pb-10 overflow-hidden text-white`}
        >
            {/* Background */}
            <div className="absolute inset-0 pb-20">
                <Image
                    src="/banner-bg.webp"
                    alt=""
                    fill
                    sizes="100vw"
                    className="object-cover"
                    priority
                />
            </div>

            {/* Logo */}
            <div className="absolute top-6 w-full flex justify-center z-10">
                <Image
                    src="/updated-logo.svg"
                    alt={logoAlt}
                    height={48}
                    width={270}
                    className="h-12 w-auto"
                    loading="eager"
                />
            </div>

            {/* Content */}
            <div
                className={`${ubuntu.className} relative z-10 w-full flex flex-col gap-5 min-h-[400px] sm:min-h-[450px] md:min-h-[500px] lg:min-h-[550px] justify-center ${isCenter ? 'items-center text-center' : 'items-start text-left'
                    }`}
            >
                {breadcrumb && <div className="text-white/85 mb-4">{breadcrumb}</div>}
                <h1 className={`${ubuntu.className} text-[36px] sm:[54px] md:text-[54px] lg:text-[54px] font-[700] leading-tight`}>
                    {title}
                </h1>
                {subtitle && <div className="text-white/80 text-lg sm:text-lg md:text-2xl lg:text-2xl">{subtitle}</div>}
                {meta && <div className="flex flex-wrap gap-4 text-white/90 text-sm sm:text-base lg:text-lg">{meta}</div>}
            </div>
        </div>
    );
};

export default PageBanner;